module.exports = __webpack_public_path__ + "img/vedrai-logo.bb548ae3.png";